module.exports = __webpack_public_path__ + "img/upload-photo.ea33ad70.svg";